import "./case.scss";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Events from "../../components/events/Events";
import SchedForm from "../../components/schedules/schedForm";
import { useState, useEffect } from "react";
import api  from "../../services/api";
import { Link, useNavigate } from "react-router-dom";
import { de } from "date-fns/locale";


const Case = () => {
  const [_case, setCase] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [schedMenuOpen, setSchedMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // const [hiddenOsintBlock, setHiddenOsintBlock] = useState(false);
  const caseId = parseInt(window.location.pathname.split("/")[2]);

  const [error, setError] = useState('');

  const handleOsintClick = (event) => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleOsintClose = () => {
    setDropdownOpen(false);
  };

  const handleOsintOptionClick = (option) => {
    console.log(option);
    handleCaseRequest(option);
    handleOsintClose();
  };

  const handleCaseRequest = (action) => {
    // We will send a post request to the backend to create a new geo request
    // using the /api/osint/event/ endpoint
    // The request will contain the caseId and the type of request
    // The type of request will be 'QUERY' for now
    // The backend will then create a new event and return the event id
    // We will then reload the events component with the new event
    let data = {};
    if (action === "GEOLOCATION") {
      data = {
      event_type: 'QUERY',
      title: 'Geo Request',
      details: `Geo Information for all targets in the case: ${_case.name}`,
      cases: [caseId],
      targets: _case.targets.map((target) => target.id),
      metadata: {query_type: 'GEOLOCATION', targets: _case.targets.map((target) =>{ return {target_id: target.id, target_name: target.name, phone_numbers: target.phones.map((phone) => phone.number)}})},

      };
    } else if (action.startsWith("OSINT")) {
      // Example actions: "OSINT_30", "OSINT_90", "OSINT_30_EXPRESS"
      const actionParts = action.split("_");
      
      // Remove the first part ("OSINT") and join the rest to handle cases like "OSINT_30_EXPRESS"
      const option = actionParts.slice(1).join("_");
      if (!option) {
        console.error('OSINT action must include an option (e.g., OSINT_30).');
        return;
      }
      data = {
      event_type: 'QUERY',
      title: 'OSINT Request',
      details: `OSINT Information for all targets in the case: ${_case.name}`,
      cases: [caseId],
      targets: _case.targets.map((target) => target.id),
      metadata: {
        option: option,
        query_type: 'OSINT', 
        targets: _case.targets.map((target) =>({ target_id: target.id, 
                                                 target_name: target.name, 
                                                 phone_numbers: target.phones.map((phone) => phone.number)
                                                }))
        },
      };
    } else {
      console.error('Invalid action');
      return;
    }
    api.post('/api/osint/events/create/', data)
      .then((res) => {
        console.log(res);
        // We will trigger a reload of the events component
        setRefresh(!refresh);
      })
      .catch((err) => {
        // TODO: show the errors as dismiss messages
        console.error(err);
      });
      
  };


  const handleEdit = () => {
    navigate(`/edit-case/${caseId}`);
  };

  useEffect(() => {
    const fetchCase = async () => {
      try {
        const res = await api.get(`/api/osint/case/${caseId}/`);
        setCase(res.data);
        // We will retrieve now the targets of the case going through the targets array
        // and fetching the target data
        const targets = await Promise.all(
          res.data.targets.map((targetId) => api.get(`/api/osint/target/${targetId}/`))
        );
        setCase({
          ...res.data,
          targets: targets.map((target) => target.data),
        });

        setLoading(false);
      } catch (err) {
        setError('Failed to load case information.');
        setLoading(false);
        console.error(err);
      }
    };
    fetchCase();
  }, [caseId]);

  if (loading) {
      return <div>Loading...</div>;
  }

  if (error) {
      return <div>{error}</div>;
  }
  const onSchedSubmit = () => {
    setSchedMenuOpen(false);
    setRefresh(!refresh);
  }


  return (
    <div className="case">
      <div className="images">
        <img
          src="/images/case_alt3.png"
          alt="Cover"
          className="cover"
        />
        <img
          src={_case.img? _case.img : "/images/case_default_cover.png"}
          alt="Case"
          className="casePic"
        />
      </div>
      <div className="caseContainer">
        <div className="cInfo">
          
          <div className="center">
            <span className="caseName">{_case.name}</span>
            <span className="caseDescription">{_case.description}</span>
            <div className="info">
              <div className="Column">
                <div>Targets:</div>
                  <div className="items">
                  {_case.targets.map((target) => (
                    <Link to={`/target/${target.id}`} key={target.id}>
                    <div key={target.id} className="item">
                      {target.name}
                    </div>
                    </Link>
                  ))}
                </div>
              </div>
              
            </div>
            {/* New Row of Buttons */}
            <div className="caseButtons">
            <button className="caseButton" onClick={()=>setSchedMenuOpen(!schedMenuOpen)}>Schedule</button>
                <button className="caseButton" onClick={()=>handleCaseRequest("GEOLOCATION")}>Geo</button>
                {/* Osint Dropdown Menu */}
              <div className="osintDropDownMenu">
                <button className="caseButton" onClick={handleOsintClick} onClose={handleOsintClose}>Osint</button>
                {dropdownOpen && <div className="dropdownMenu">
                  <p className="menuOption" onClick={() => handleOsintOptionClick("OSINT_30")}>
                    30 days
                  </p>
                  <p className="menuOption" onClick={() => handleOsintOptionClick("OSINT_60")}>
                    60 days
                  </p>
                  <p className="menuOption" onClick={() => handleOsintOptionClick("OSINT_90")}>
                    90 days
                  </p>
                  <p className="menuOption" onClick={() => handleOsintOptionClick("OSINT_30_EXPRESS")}>
                    30 days Express
                  </p>
                  <p className="menuOption" onClick={() => handleOsintOptionClick("OSINT_60_EXPRESS")}>
                    60 days Express
                  </p>
                  <p className="menuOption" onClick={() => handleOsintOptionClick("OSINT_90_EXPRESS")}>
                    90 days Express
                  </p>
                  {/* Add more MenuItem components as needed */}
                </div>}
              </div>
            </div>
          </div>
          <div className="right">
            <MoreVertIcon onClick={() => setMenuOpen(!menuOpen)} />
            {menuOpen && <button onClick={handleEdit}>Edit</button>}
          </div>
        </div>
        {schedMenuOpen && <SchedForm caseId={caseId} onSubmit={onSchedSubmit}/>}
        <Events caseId={caseId} refresh={refresh}/>
      </div>
    </div>
  );
};

export default Case;
